class ReportCollection extends App.Collections.BaseCollection {
    url = 'Report';
    model = App.Models.Report;

    filterWithCriteria = async (obj) => {
        await this.doAjax(obj, 'Report/filter?criteria=' + obj.criteria);
    }
}

App.Collections.Reports = ReportCollection;
